var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
export var ODFlexContentsContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: ", ";\n  flex-grow: 99;\n"], ["\n  display: flex;\n  flex-direction: ", ";\n  flex-grow: 99;\n"])), function (p) { return (p.row ? 'row' : 'column'); });
var templateObject_1;
//# sourceMappingURL=ODFlexContentsContainer.js.map